module.exports = __webpack_public_path__ + "img/ESWA.21248803.png";